import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import HeroSection from './sections/HeroSection';
import AboutSection from './sections/AboutSection';
import HowItWorksSection from './sections/HowItWorksSection';
import WhoCanApplySection from './sections/WhoCanApplySection';
import RequirementsSection from './sections/RequirementsSection';
import ServicesSection from './sections/ServicesSection';
import WhyGoldcifSection from './sections/WhyGoldcifSection';
import FAQSection from './sections/FAQSection';
import BlogSection from './sections/BlogSection';
import ApplicationSection from './sections/ApplicationSection';
import Header from './layout/Header';
import Footer from './layout/Footer';

const SellersLandingPage = () => {
  const navigate = useNavigate();

  // Force scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleBackToHome = () => {
    navigate('/');
  };

  return (
    <div className="min-h-screen bg-background">
      {/* Back to Home Navigation */}
      <nav className="fixed top-0 w-full bg-white/90 backdrop-blur-sm z-50 border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-4">
            <button 
              onClick={handleBackToHome}
              className="flex items-center text-gray-600 hover:text-[#040F2D] transition-colors group"
            >
              <ArrowLeft className="w-5 h-5 mr-2 group-hover:-translate-x-1 transition-transform" />
              Back to Home
            </button>
            <div className="flex items-center space-x-2">
              <img 
                src="/goldcif-logo.png" 
                alt="GOLDCIF Logo" 
                className="w-8 h-8 object-contain"
              />
              <span className="text-xl font-bold text-[#040F2D]">GOLDCIF</span>
            </div>
          </div>
        </div>
      </nav>
      
      {/* Add top padding to account for fixed nav */}
      <div className="pt-20">
        <Header />
        <main>
        <HeroSection />
        <AboutSection />
        <HowItWorksSection />
        <WhoCanApplySection />
        <RequirementsSection />
        <ServicesSection />
        <WhyGoldcifSection />
        <FAQSection />
        <BlogSection />
        <ApplicationSection />
        </main>
        <Footer />
      </div>
    </div>
  );
};

export default SellersLandingPage;